import { FC, useEffect, useState } from 'react';

import { getPurpurIcon } from '@telialt/common-icon/src/utils';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { usePathname } from '@telialt/utils/src/pathname';
import { useSegment } from '@telialt/utils/src/segment';
import { useUserDataQueryBase } from '@telialt/utils/src/SSO/useUserData';
import { getIsUserAuthorized } from '@telialt/utils/src/SSO/utils';

import { getUserMenuItems } from '../../constants';
import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { MenuItemIcon } from '../MenuItem/MenuItem.styles';
import { GuestButton, UserButtonSkeleton, UserButtonSkeletonWrapper, UserIconWrapper } from './MenuItemUser.styles';
import { UserMenu } from './UserMenu';
import { UserMenuMobile } from './UserMenuMobile';

interface Props {
    item: NavigationItem;
}

export const MenuItemUser: FC<Props> = ({ item }) => {
    const [isMounted, setIsMounted] = useState(false);
    const segment = useSegment();
    const currentPath = usePathname();

    const { userData } = useUserDataQueryBase({
        isEnabled: isMounted,
    });

    const { title, displayOption, url, icon } = item;
    const guestPurpurIcon = getPurpurIcon(icon);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return (
            <UserButtonSkeletonWrapper $displayOption={displayOption}>
                <UserButtonSkeleton />
                <UserButtonSkeleton />
            </UserButtonSkeletonWrapper>
        );
    }

    if (!getIsUserAuthorized()) {
        return (
            <GuestButton $displayOption={displayOption} href={url} data-test={NAVIGATION_TEST_IDS.USER}>
                <UserIconWrapper>{guestPurpurIcon && <MenuItemIcon svg={guestPurpurIcon} size="sm" />}</UserIconWrapper>
                {title}
            </GuestButton>
        );
    }

    const menuItems = getUserMenuItems(userData?.isStrong, segment, currentPath);

    if (displayOption === 'Mobile only') {
        return <UserMenuMobile menuItems={menuItems} />;
    }

    return <UserMenu menuItems={menuItems} />;
};
